import { StartingTeacherRoutePage } from "./StartingTeacherRoutePage.js";

export function PassportDashboardPage() {
  return <StartingTeacherRoutePage />;
}
